import * as React from "react";
function CleverIcon({ title, titleId, className, ...props }, svgRef) {
	return (
		<svg
			ref={svgRef}
			className={className}
			id="clever-icon"
			xmlns="http://www.w3.org/2000/svg"
			x="0px"
			y="0px"
			viewBox="0 0 128 128"
			width="128"
			height="128"
			fill="currentColor"
			stroke="transparent"
			aria-hidden="true"
			aria-labelledby={titleId}>
			{title && <title id={titleId}>{title}</title>}
			<path d="M 123.70521,33.233735 C 113.14048,13.748884 92.011016,0.9266332 66.878996,0.9266332 c -35.151155,0 -63.5802447,28.0126028 -63.5802447,62.7193538 0,34.706755 28.4290897,62.720283 63.5802447,62.782453 25.131084,0 46.260544,-12.82133 56.826214,-32.307103 L 101.87119,82.151861 c -7.266729,12.474277 -19.047751,20.338549 -34.991254,20.338549 -21.481261,0 -38.289248,-17.590924 -38.289248,-38.812874 0,-21.22195 16.807987,-38.812877 38.289248,-38.812877 15.943503,0 27.724525,7.863349 34.991254,20.338553 z" />
		</svg>
	);
}
const ForwardRef = React.forwardRef(CleverIcon);
export default ForwardRef;
